import React, { useEffect, useState } from "react";
import { Tooltip } from "antd";
import { DEFAULT_PROFILE_IMAGE } from "../../../app/utils/common/baseUrl";
import { getAvatarColor, getInitials } from "../../../app/utils/projectBoard/boardDesignTokens";
import "./BoardAvatar.scss";

const DEFAULT_PROFILE_IMAGE_ID = "ypp3aruo8xfek8nnqg50";

const isUsableAvatarImage = (imageUrl) => {
  const url = String(imageUrl ?? "").trim();
  if (!url) return false;
  if (url === DEFAULT_PROFILE_IMAGE) return false;
  if (url.includes(DEFAULT_PROFILE_IMAGE_ID)) return false;
  return true;
};

const BoardAvatar = ({
  name,
  userId,
  imageUrl,
  size = "sm",
  className = "",
  tooltip,
}) => {
  const [imgFailed, setImgFailed] = useState(false);
  const displayName = String(name || "").trim();
  const tooltipLabel = tooltip != null ? tooltip : displayName;
  const initials = getInitials(displayName);
  const bgColor = getAvatarColor(userId);
  const showImage = isUsableAvatarImage(imageUrl) && !imgFailed;

  useEffect(() => {
    setImgFailed(false);
  }, [imageUrl]);

  const avatar = (
    <span
      className={`pb-avatar pb-avatar--${size} ${className}`.trim()}
      style={!showImage ? { backgroundColor: bgColor } : undefined}
      aria-label={displayName || "Member"}
    >
      {showImage ? (
        <img
          src={imageUrl}
          alt={displayName || "Member"}
          onError={() => setImgFailed(true)}
        />
      ) : (
        initials
      )}
    </span>
  );

  if (!tooltipLabel) return avatar;

  return (
    <Tooltip title={tooltipLabel} mouseEnterDelay={0.15} placement="bottom">
      {avatar}
    </Tooltip>
  );
};

export default BoardAvatar;
